import React, { Component } from 'react';
import AnswerContainer from './AnswerContainer';

class AnswerList extends Component {
    render() {
        let contents;
        if (this.props.answers) {
            contents = this.props.answers.map((item, index) => (
                <AnswerContainer
                    key={`${index} ${item}`}
                    enabled={this.props.answered}
                    text={item}
                />
            ));
        }
        return <div className="AnswerList">{contents}</div>;
    }
}
export default AnswerList;
